import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import App from "./App";
import UnsupportedRedirectPage from "./UnsupportedRedirectPage/UnsupportedRedirectPage";
import ResetPasswordPage from "./AuthComponents/ResetPasswordPage";
import VerifyEmailPage from "./AuthComponents/VerifyEmailPage";
import UnsubscribeEmailPage from "./AuthComponents/UnsubscribeEmailPage";
import TermsPage from "./LegalComponents/TermsPage";

import ErrorPage from "./ErrorPageComponents/ErrorPage";

import { createBrowserRouter, RouterProvider, redirect } from "react-router-dom";

import reportWebVitals from "./reportWebVitals";
import ReactGA from "react-ga4";

const TRACKING_ID = "G-YC2NSLRQV2";
ReactGA.initialize(TRACKING_ID);

const router = createBrowserRouter([
  {
    path: "/reset-password/:uidb64/:token",
    element: <ResetPasswordPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/verify-email/:uidb64?/:token?",
    element: <VerifyEmailPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/unsubscribe-email/:uidb64?/:token?",
    element: <UnsubscribeEmailPage />, // TODO: fix this
    errorElement: <ErrorPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/register",
    element: <App />,
    errorElement: <ErrorPage goTo={"/"} />,
  },
  {
    path: "/*",
    element: <App />,
    errorElement: <ErrorPage goTo={"/"} />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
